import React from "react";
import { Reveal, Overline } from "../components/site/Reveal";
import { PEOPLE_ITEMS, IMAGES } from "../data/content";

export const People = () => (
  <section id="people" className="relative bg-bg-light py-24 sm:py-32" data-testid="people-section">
    <div className="mx-auto grid max-w-[1400px] items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal className="order-2 lg:order-1">
        <div className="relative overflow-hidden rounded-[2rem] card-shadow">
          <img src={IMAGES.people} alt="Diverse professional team collaborating with technology" className="aspect-[5/4] w-full object-cover transition-transform duration-700 hover:scale-105" />
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal><Overline>People & Organisational Development</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Building High-Performing Organisations <span className="text-gradient-emerald">Through People</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-charcoal/70">
            We combine business performance with an evidence-based understanding of workplace behaviour — helping
            organisations understand the relationship between people, systems, leadership, culture and performance.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {PEOPLE_ITEMS.map((p) => (
              <span key={p} className="rounded-full bg-white px-4 py-2 text-sm font-medium text-charcoal/75 shadow-[0_2px_10px_rgba(3,31,20,0.04)] transition-colors duration-300 hover:text-emerald-base">
                {p}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
